import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  SEND_AUDIENCE_INTEGRATION_JOB,
  SEND_AUDIENCE_INTEGRATION_JOB_SUCCESS,
} from '../../constants';

import { toast } from 'react-toastify';

let toastId = 'downloadAudienceBuilder';

const sendAudienceIntegrationJob = (action$, state$) =>
  action$.pipe(
    ofType(SEND_AUDIENCE_INTEGRATION_JOB),
    switchMap(action => {

      toastId = toast('Activating Audience...', {
        id: toastId,
        autoClose: false,
        position: 'top-center',
        style: { textAlign: 'center' },
        closeButton: false, // Remove the closeButton
      });

      return ajax({
        url: `${state$.value.auth.audienceBuilderServer}/jobs`,
        headers: {
          Authorization: state$.value.auth.token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(action.payload),
        responseType: 'json',
        crossDomain: true,
        method: 'POST',
      }).pipe(
        map(response => {

          toast.update(toastId, {
            id: toastId,
            type: toast.TYPE.INFO,
            render: 'Activation Completed',
            autoClose: 3000,
            hideProgressBar: true,
            progress: undefined,
            style: {
              backgroundColor: 'rgb(237, 247, 237)',
              color: 'rgb(30, 70, 32)',
              textAlign: 'center',
            },
            closeButton: true, // The closeButton defined on ToastContainer will be used
          });

          return {
            type: SEND_AUDIENCE_INTEGRATION_JOB_SUCCESS,
          };
        }),
        catchError(error => {
          toast.update(toastId, {
            id: toastId,
            type: toast.TYPE.INFO,
            render: 'Activation Failed',
            autoClose: 6000,
            hideProgressBar: true,
            progress: undefined,
            style: {
              backgroundColor: 'rgb(253, 236, 234)',
              color: 'rgb(97, 26, 21)',
              textAlign: 'center',
            },
            closeButton: null, // The closeButton defined on ToastContainer will be used
          });

          console.log(error);
        })
      );
    })
  );

export default sendAudienceIntegrationJob;
